module.exports = __webpack_public_path__ + "src/assets/img/okkomovie.c4c096cd.jpg";